<template>
    <div>
        <div id="learnosity_assess"></div>
        <div id="local_practice_review"></div>
        <div v-if="note">
            <b-popover ref="notePopover" :target="noteButtonId" triggers="click" :show.sync="notePop" :placement="'right'">
                <div v-html="note"></div>
            </b-popover>
        </div>
        <div v-if="example">
            <b-popover ref="examplePopover" :target="exampleButtonId" triggers="click" :show.sync="examplePop" :placement="'right'">
                <div v-html="example"></div>
            </b-popover>
        </div>
        <div v-if="topSkill.length > 0">
            <b-popover ref="topSkillPopover" :target="topSkillLinkId" triggers="click" :show.sync="topSkillPop" :placement="'top'">
                <div>
                    <div><span>TOP THINGS YOU EXCEL AT:</span></div>
                    <div v-for="(label, index) in topSkill">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="topCriteria.length > 0">
            <b-popover ref="topCriteriaPopover" :target="topCriteriaLinkId" triggers="click" :show.sync="topCriteriaPop" :placement="'top'">
                <div>
                    <div><span>TOP CAREER CRITERIA:</span></div>
                    <div v-for="(label, index) in topCriteria">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="mostEnergizeYou.length > 0">
            <b-popover ref="mostEnergizeYouPopover" :target="mostEnergizeYouLinkId" triggers="click" :show.sync="mostEnergizeYouPop" :placement="'top'">
                <div>
                    <div><span>TOP THINGS THAT ENERGIZE YOU:</span></div>
                    <div v-for="(label, index) in mostEnergizeYou">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="currentQuestions0.length > 0">
            <b-popover ref="questionListPopover0" :target="currentQuestionId0" triggers="click" :show.sync="questionListPop0" :placement="'right'">
                <div class="header-title float-right">
                    <button size="sm" style="font-size: 10px;margin-right: -10px; margin-top: -10px;" @click="closeQuestionPopover(0)">X</button>
                </div>
                <div class="content-body">
                    <div><span>YOUR CURRENT QUESTIONS ARE:</span></div>
                    <div v-for="(label, index) in currentQuestions0">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="currentQuestions1.length > 0">
            <b-popover ref="questionListPopover1" :target="currentQuestionId1" triggers="click" :show.sync="questionListPop1" :placement="'right'">
                <div class="header-title float-right">
                    <button size="sm" style="font-size: 10px;margin-right: -10px; margin-top: -10px;" @click="closeQuestionPopover(1)">X</button>
                </div>
                <div class="content-body">
                    <div><span>YOUR CURRENT QUESTIONS ARE:</span></div>
                    <div v-for="(label, index) in currentQuestions1">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="currentQuestions2.length > 0">
            <b-popover ref="questionListPopover2" :target="currentQuestionId2" triggers="click" :show.sync="questionListPop2" :placement="'right'">
                <div class="header-title float-right">
                    <button size="sm" style="font-size: 10px;margin-right: -10px; margin-top: -10px;" @click="closeQuestionPopover(2)">X</button>
                </div>
                <div class="content-body">
                    <div><span>YOUR CURRENT QUESTIONS ARE:</span></div>
                    <div v-for="(label, index) in currentQuestions2">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="currentQuestions3.length > 0">
            <b-popover ref="questionListPopover3" :target="currentQuestionId3" triggers="click" :show.sync="questionListPop3" :placement="'right'">
                <div class="header-title float-right">
                    <button size="sm" style="font-size: 10px;margin-right: -10px; margin-top: -10px;" @click="closeQuestionPopover(3)">X</button>
                </div>
                <div class="content-body">
                    <div><span>YOUR CURRENT QUESTIONS ARE:</span></div>
                    <div v-for="(label, index) in currentQuestions3">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="currentQuestions4.length > 0">
            <b-popover ref="questionListPopover4" :target="currentQuestionId4" triggers="click" :show.sync="questionListPop4" :placement="'right'">
                <div class="header-title float-right">
                    <button size="sm" style="font-size: 10px;margin-right: -10px; margin-top: -10px;" @click="closeQuestionPopover(4)">X</button>
                </div>
                <div class="content-body">
                    <div><span>YOUR CURRENT QUESTIONS ARE:</span></div>
                    <div v-for="(label, index) in currentQuestions4">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        <div v-if="currentQuestions5.length > 0">
            <b-popover ref="questionListPopover5" :target="currentQuestionId5" triggers="click" :show.sync="questionListPop5" :placement="'right'">
                <div class="header-title float-right">
                    <button size="sm" style="font-size: 10px;margin-right: -10px; margin-top: -10px;" @click="closeQuestionPopover(5)">X</button>
                </div>
                <div class="content-body">
                    <div><span>YOUR CURRENT QUESTIONS ARE:</span></div>
                    <div v-for="(label, index) in currentQuestions5">
                        <span>{{index + 1}}. {{label}}</span>
                    </div>
                </div>
            </b-popover>
        </div>
        
        <b-modal class="page_modal" id="conversationSample" size="xlg" centered hide-footer>
            <div slot="modal-header" class="header-section">
                <div class="popup-heading-btn">
                    <button type="button" aria-label="Close" class="attempt-report-close" @click="closeConversationSample">x</button>
                </div>
            </div>

            <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
                <iframe class="embed-responsive-item" src="https://pragya2.s3-us-west-2.amazonaws.com/5d0a2f12e4b0b86090689495-Sample%20QuestionsPDF.pdf?versionId=cU1Mbo3z9wACGfMDqAJxetRx.6LsFMPx" allowfullscreen></iframe>
            </div>
        </b-modal>
        
    </div>
</template>

<script>
  /* global LearnosityItems:true */
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import moment from 'moment'

  export default {
    name: 'quest-launch-assessment',
    props: ['uuid', 'courseId', 'sessionId', 'canEdit', 'careerIdeaId'],
    data () {
      return {
        itemsApp: {},
        isCompleted: false,
        userCareerCriteriaList: [],
        dbUserCareerCriteriaList: [],
        isUserCareerCriteriaSaved: false,
        dirty: false,
        isShowWarning: true,
        example: undefined,
        exampleButtonId: '',
        examplePop: false,
        note: undefined,
        noteButtonId: '',
        notePop: false,
        userTopSkillList: [],
        userMostEnergizeWorkList: [],
        userConversationQuestionMap: {},
        userMostInterestingIdeaList: [],
        currentQuestionId0: '',
        currentQuestions0: [],
        questionListPop0: false,
        currentQuestionId1: '',
        currentQuestions1: [],
        questionListPop1: false,
        currentQuestionId2: '',
        currentQuestions2: [],
        questionListPop2: false,
        currentQuestionId3: '',
        currentQuestions3: [],
        questionListPop3: false,
        currentQuestionId4: '',
        currentQuestions4: [],
        questionListPop4: false,
        currentQuestionId5: '',
        currentQuestions5: [],
        questionListPop5: false,
        topSkill: [],
        topSkillPop: false,
        topSkillLinkId: '',
        topCriteria: [],
        topCriteriaPop: false,
        topCriteriaLinkId: '',
        mostEnergizeYou: [],
        mostEnergizeYouPop: false,
        mostEnergizeYouLinkId: '',
        dbCareerIdeaAndConnection: {},
        isMainQuest: false,
        isRatingQuest: false,
        isMainQuestWorksheet: false
      }
    },

    mounted () {
      if (this.$route.query.isMainQuest) {
        this.isMainQuest = this.$route.query.isMainQuest
      }
      if (this.$route.query.isRatingQuest) {
        this.isRatingQuest = this.$route.query.isRatingQuest
      }
      if (this.$route.query.isMainQuestWorksheet) {
        this.isMainQuestWorksheet = this.$route.query.isMainQuestWorksheet
      }
      if (this.isRatingQuest) {
        $('.header > .heading').text('Conversation Scorecard')
      }
      this.initLaunchAssessment()
    },

    watch: {
      userCareerCriteriaList (newVal) {
        this.dirty = (JSON.stringify(newVal) !== JSON.stringify(this.dbUserCareerCriteriaList))
      }
    },

    beforeDestroy () {
      if (typeof this.itemsApp.reset === 'function') {
        this.itemsApp.reset()
      }
    },

    methods: {
      ...mapActions([
        'launchAssessment',
        'updateAttempt',
        'showLocalPracticeReview',
        'updateUserCareerCriteriaList',
        'loadNextEntityDetail',
        'updateUserTopSkillList',
        'updateUserMostEnergizeWorkList',
        'updateUserConversationQuestionMap',
        'updateUserMostInterestingIdeaList',
        'createCareerIdeaAndConnection',
        'loadCareerIdeaAndConnection'
      ]),

      initLaunchAssessment () {
        this.dbCareerIdeaAndConnection = {}
        this.loadCareerIdeaAndConnection({courseId: this.courseId, isMainQuest: this.isMainQuest}).then(res => {
          if (res) {
            this.dbCareerIdeaAndConnection = res
          }
        })
        this.launchAssessment({uuid: this.uuid, courseId: this.courseId, sessionId: this.sessionId}).then(res => {
          if (res) {
            this.isCompleted = res.isCompleted
            if (this.isCompleted && !this.canEdit) {
              return this.$router.push({ name: 'clearlyNextStudentDashboard' })
            }
            const sessionId = res.sessionId
            const externalId = res.externalId
            const isLocalPractice = res.isLocalPractice
            this.isShowWarning = !this.canEdit
            this.userTopSkillList = res.userTopSkillList
            this.userMostEnergizeWorkList = res.userMostEnergizeWorkList
            this.userCareerCriteriaList = res.userCareerCriteriaList
            this.dbUserCareerCriteriaList = res.userCareerCriteriaList
            this.userConversationQuestionMap = res.userConversationQuestionMap
            this.userMostInterestingIdeaList = res.userMostInterestingIdeaList
            const signedRequest = JSON.parse(res.signedRequest)
            this.initialize(signedRequest, sessionId, externalId, isLocalPractice)
          }
        })
      },

      initialize (signedRequest, sessionId, externalId, isLocalPractice) {
        var self = this
        self.itemsApp = LearnosityItems.init(signedRequest, {
          'readyListener': () => {
            self.bindReadyListener(sessionId, externalId, isLocalPractice)
          },
          'errorListener': (event) => {
            console.log('error: ', event)
          }
        })
      },

      bindReadyListener (sessionId, externalId, isLocalPractice) {
        // let storyResponse = {}
        let careerIdeaAndConnection = {}
        $('.progress.pos-middle').height('25px')
        let assessApp = this.itemsApp.assessApp()
        if (this.isRatingQuest) {
          $('.item-prev').addClass('d-none')
          $('.header > .heading').text('Conversation Scorecard')
        } else {
          if (this.isCompleted) {
            assessApp.items().goto(0)
          }
        }
        let items = this.itemsApp.getItems()
        let itemCount = Object.keys(items).length
        if (itemCount === 1) {
          $('.item-prev').addClass('d-none')
        }
        assessApp.on('item:load', (event) => {
          $('.lrn_ratingInfo_icon_wrap').hide()
          if (this.isRatingQuest) {
            $('.lrn-well').hide()
            $('table').hide()
            $('table.table-bordered').show()
            $('.current-item-pos').hide()
          } else if (itemCount === 1) {
            $('.current-item-pos').hide()
          }
          this.updateWarningFlagOnNavigation(assessApp)
          this.generateTopSkillTopCriteriaMostEnergizeLink()
          this.reorderLabelsBasedOnUserCareerCriteriaList()
          this.showUserConversationQuestionMap(sessionId)
          this.generateExmapleAndNoteButton()
          this.showUserCareerCriteriaList()
          this.generateConversationWorksheetLink(assessApp, sessionId, externalId)
          this.showCreatedCareerIdeaAndConnection()
          this.showUserMostInterestingIdeaList()
          if ($('.test-submit').css('display') !== 'none') {
            this.showConsolidatedStoryResponse()
            if (this.isCompleted) {
              let doneBtn = '<button type="button" class="lrn_btn lrn_btn_blue test-done pos-right">Done</button>'
              $('.test-submit').after($(doneBtn))
              $('.test-done').unbind('click').click(() => {
                if (this.careerIdeaId) {
                  return this.$router.push({name: 'connection', params: {careerIdeaId: this.careerIdeaId}})
                } else {
                  return this.$router.push({name: 'clearlyNextStudentDashboard'})
                }
              })
              $('.test-submit').hide()
            } else {
              $('.test-submit').removeClass('item-next')
            }
          } else {
            $('.test-done').remove()
          }
        }).on('item:beforeunload', (event) => {
          let responseIds = this.itemsApp.getCurrentItem().response_ids
          $.each(responseIds, (index, responseId) => {
            let questionObject = this.itemsApp.question(responseId)
            let question = questionObject.getQuestion()
            // console.log('Question: ', question)
            // this.captureUserStoryResponse(question, storyResponse)
            if (!this.isCompleted && (question.type !== 'rating')) {
              this.populateUserConversationQuestionMap(sessionId, question)
              if (Object.keys(this.userConversationQuestionMap).length > 0) {
                this.updateUserConversationQuestionMap(this.userConversationQuestionMap)
              }
            }
            if (this.isShowWarning) {
              if (this.showWarningAlertDialog(assessApp, event, questionObject, question)) {
                return false
              }
              if (this.showWarningAlertDialogForAtLeastAnswerRequired(assessApp, event, (index + 1), questionObject, question)) {
                return false
              }
            }
            careerIdeaAndConnection = this.captureCareerIdeaAndConnectionData(question)
            if (Object.keys(careerIdeaAndConnection).length > 0) {
              if (Object.keys(this.dbCareerIdeaAndConnection).length > 0) {
                careerIdeaAndConnection.careerIdeaId = this.dbCareerIdeaAndConnection.careerIdeaId
                careerIdeaAndConnection.connectionId = this.dbCareerIdeaAndConnection.connectionId
              }
              this.dbCareerIdeaAndConnection = careerIdeaAndConnection
              this.createCareerIdeaAndConnection(careerIdeaAndConnection).then(isCreated => {
                if (isCreated && !this.isCompleted) {
                  this.loadCareerIdeaAndConnection({courseId: this.courseId, isMainQuest: this.isMainQuest}).then(res => {
                    if (res) {
                      this.dbCareerIdeaAndConnection = res
                    }
                  })
                }
              })
            }
            if (this.saveMeetingDateToConnection(question, event)) {
              return false
            }
          })
        }).on('item:unload', (event) => {
          this.reset()
          $.each(this.itemsApp.getCurrentItem().response_ids, (index, responseId) => {
            var questionObject = this.itemsApp.question(responseId)
            var question = questionObject.getQuestion()
            if (question.type === 'orderlist') {
              this.userCareerCriteriaList = this.populateUserCareerCriteriaList(question)
              setTimeout(() => {
                this.saveUserCareerCriteriaList()
                this.isUserCareerCriteriaSaved = true
              }, 500)
            } else {
              if (this.isUserCareerCriteriaSaved) {
                this.saveUserCareerCriteriaResponse()
                this.isUserCareerCriteriaSaved = false
              }
              this.saveUserTopSkillList(question)
              this.saveUserMostEnergizeWorkList(question)
              this.saveUserMostInterestingIdeaList(question)
            }
          })
        }).on('test:finished:submit', (event) => {
          if (isLocalPractice) {
            let count = 1
            $.each(this.itemsApp.getItems(), (index, item) => {
              let element = '<span class="learnosity-item" data-reference="' + index + '">'
              let title = '<span class="question_title" style="display: none; font-size: larger; font-family: robotoSlab_Light;">Question ' + count + '</span>'
              let review = title + element
              $(review).appendTo('#local_practice_review')
              count++
            })
            let responses = this.itemsApp.getResponses()
            this.showReview(sessionId, responses)
          } else {
            this.saveAndExit(sessionId, externalId, true)
          }
        }).on('test:submit:error', (event) => {
          console.log('submit has failed: ', event)
        })
      },

      updateWarningFlagOnNavigation (assessApp) {
        $('.item-prev').unbind('click').click(() => {
          this.isShowWarning = false
        })
        $('.item-next').unbind('click').click(() => {
          this.isShowWarning = true
        })
        /*
        let self = this
        this.itemsApp.getCurrentItem((item) => {
          let itemPosition = assessApp.getItemPosition(item.reference)
          $('ul.slides-vertical-pagination li').unbind('click').click(() => {
            let itemIndex = $(this).index()
            if (itemIndex > itemPosition) {
              self.isShowWarning = true
            } else {
              self.isShowWarning = false
            }
          })
        })
        */
      },

      showWarningAlertDialog (assessApp, event, questionObject, question) {
        let retValue = false
        if (question.type === 'mcq') {
          let label = 'at least one option'
          if (question.options.length === 1) {
            label = question.options[0].label
            if (label.lastIndexOf('.') !== -1) {
              label = label.substring(0, label.lastIndexOf('.'))
            }
          }
          let validResponseCount = question.metadata.valid_response_count
          if (validResponseCount) {
            let questionResponse = questionObject.getResponse()
            let currentResponseCount = (questionResponse) ? questionResponse.value.reduce((acc, curr) => {
              return acc + (curr ? 1 : 0)
            }, 0) : 0
            if (currentResponseCount < validResponseCount) {
              assessApp.dialogs().custom.show({
                'header': 'Action Required',
                'body': 'Please select "' + label + '" to proceed further.'
              })
              event.preventDefault()
              retValue = true
            }
          }
        } else if (question.type === 'choicematrix') {
          let validResponseCount = question.metadata.valid_response_count
          if (validResponseCount) {
            let questionResponse = questionObject.getResponse()
            let currentResponseCount = (questionResponse) ? questionResponse.value.reduce((acc, curr) => {
              return acc + (curr ? 1 : 0)
            }, 0) : 0
            if (currentResponseCount < validResponseCount) {
              retValue = this.showPromptForAtLeastAnswerRequired(assessApp, event, validResponseCount)
            }
          }
        }
        return retValue
      },

      showWarningAlertDialogForAtLeastAnswerRequired (assessApp, event, index, questionObject, question) {
        let retValue = false
        if (question.metadata.required && question.metadata.required === '1') {
          let validResponseCount = question.metadata.minNumberOfFields
          if (validResponseCount && validResponseCount > 0) {
            let questionResponse = questionObject.getResponse()
            let currentResponseCount = (questionResponse) ? ((questionResponse.type === 'array') ? questionResponse.value.reduce((acc, curr) => {
              return acc + (curr ? 1 : 0)
            }, 0) : questionResponse.value) : 0
            if (currentResponseCount < validResponseCount) {
              let label = 'Step #' + index
              retValue = this.showPromptForAtLeastAnswerRequired(assessApp, event, validResponseCount, label)
            }
          }
        }
        return retValue
      },

      showPromptForAtLeastAnswerRequired (assessApp, event, validCount, label) {
        assessApp.dialogs().custom.show({
          'header': 'Action Required',
          'body': (label || 'This question') + ' requires at least ' + validCount + ((validCount === 1 || validCount === '1') ? ' answer.' : ' answers.')
        })
        event.preventDefault()
        return true
      },

      captureUserStoryResponse (question, storyResponse) {
        let stimulus = question.stimulus
        if (stimulus) {
          // let text = $(stimulus).text()
          if (stimulus.indexOf(' sentence in the box below') !== -1) {
            $('.lrn_cloze_response').each(function (i) {
              if (!$(this).hasClass('lrn_hidden')) {
                let value = $.trim($(this).val())
                if (value.length > 0) {
                  storyResponse[question.response_id] = value
                }
              }
            })
          }
        }
      },

      saveMeetingDateToConnection (question, event) {
        let retValue = false
        let isConversationWorksheet = false
        let responseId = question.response_id
        let parent = '#' + responseId + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div > table.table-bordered > tbody > tr:eq(0)'
        $(parent).children().each(function (i) {
          let text = $(this).text()
          if (!isConversationWorksheet && (text === 'Meeting Date (mm/dd/yyyy)')) {
            isConversationWorksheet = true
            return false
          }
        })
        if (isConversationWorksheet) {
          if (Object.keys(this.dbCareerIdeaAndConnection).length > 0) {
            let meetingDate = null
            let responses = this.itemsApp.getResponses()
            if (Object.keys(responses).length > 0) {
              let response = responses[responseId]
              let values = (response && response.value) ? response.value : []
              if (Array.isArray(values) && values.length > 0) {
                meetingDate = values[0]
              }
            }
            if (meetingDate) {
              let isValid = moment(meetingDate, 'MM/DD/YYYY', true).isValid()
              if (isValid) {
                let currentDate = this.changeMillisToDate(moment().valueOf())
                let isSameOrAfter = moment(meetingDate, 'MM/DD/YYYY', true).isSameOrAfter(currentDate)
                if (isSameOrAfter) {
                  this.dbCareerIdeaAndConnection.meetingDate = moment.utc(meetingDate, 'MM/DD/YYYY').valueOf()
                  this.createCareerIdeaAndConnection(this.dbCareerIdeaAndConnection)
                } else {
                  alert('Date entered must be on or after today')
                  event.preventDefault()
                  retValue = true
                }
              } else {
                alert('Please enter a valid date. Format must be "MM/DD/YYYY"')
                event.preventDefault()
                retValue = true
              }
            } else if (this.isMainQuestWorksheet) {
              alert('Please enter the meeting date. Format must be "MM/DD/YYYY"')
              event.preventDefault()
              retValue = true
            }
          }
        }
        return retValue
      },

      showReview (sessionId, responses) {
        this.showLocalPracticeReview({uuid: this.uuid, courseId: this.courseId, sessionId: sessionId, responses: responses}).then(res => {
          if (res) {
            if (typeof this.itemsApp.reset === 'function') {
              this.itemsApp.reset()
              $('#learnosity_assess').hide()
            }
            let self = this
            const signedRequest = JSON.parse(res.signedRequest)
            self.itemsApp = LearnosityItems.init(signedRequest, {
              'readyListener': function () {
                $('.question_title').css('display', 'block')
                self.$emit('localPracticeReviewLoaded', true)
              },
              'errorListener': function (event) {
                console.log('error: ', event)
              }
            })
          }
        })
      },

      showConsolidatedStoryResponse () {
        let storyResponse = []
        $('.final_statement').remove()
        let attemptedItems = this.itemsApp.attemptedItems()
        if (attemptedItems && attemptedItems.length > 0) {
          let items = this.itemsApp.getItems()
          let responses = this.itemsApp.getResponses()
          this.itemsApp.getCurrentItem((item) => {
            let curResponseId = item.response_ids[0]
            $.each(attemptedItems, (i, itemId) => {
              let responseId = items[itemId].response_ids[0]
              if (curResponseId !== responseId) {
                let response = responses[responseId]
                let values = (response && response.value) ? response.value : []
                if (Array.isArray(values) && values.length > 0) {
                  let value = values[0]
                  if (value.length > 0) {
                    storyResponse.push(value)
                  }
                }
              }
            })
            let final = ''
            $.each(storyResponse, (j, value) => {
              if (final.length > 0) {
                final += '<hr>'
              }
              final += '<span class="previous_statement">' + value + '</span>'
            })
            if (final.length > 0) {
              let featureId = item.feature_ids[0] + '_0'
              let customElem = '<div class="final_statement" style="height: 250px; max-width: 100%; width: 100%; padding: 10px 10px; border: 1px solid #ccc; overflow-y: auto;">' + final + '</div>'
              $('#' + featureId + ' > div').children().each(function (i) {
                let text = $(this).text()
                if (text.toLowerCase().indexOf('take a moment to review the sentences you have just constructed') !== -1) {
                  $(this).after(customElem)
                  return false
                }
              })
            }
          })
        }
        /*
        this.itemsApp.getCurrentItem((item) => {
          if (Object.keys(storyResponse).length > 0) {
            let final = ''
            for (var key in storyResponse) {
              if (final.length > 0) {
                final += '<hr>'
              }
              final += '<span class="previous_statement">' + storyResponse[key] + '</span>'
            }
            if (final.length > 0) {
              $('.final_statement').remove()
              let featureId = item.feature_ids[0] + '_0'
              let customElem = '<div class="final_statement" style="height: 250px; max-width: 100%; width: 100%; padding: 10px 10px; border: 1px solid #ccc; overflow-y: auto;">' + final + '</div>'
              // $('#' + featureId + ' > div > p:eq(1)').after(customElem)
              $('#' + featureId + ' > div').children().each(function (i) {
                let text = $(this).text()
                if (text.toLowerCase().indexOf('take a moment to review the sentences you have just constructed') !== -1) {
                  $(this).after(customElem)
                  return false
                }
              })
            }
          }
        })
        */
      },

      showUserCareerCriteriaList () {
        let careerCriteriaList = this.userCareerCriteriaList
        if (careerCriteriaList.length > 0) {
          let pos = 0
          this.itemsApp.getCurrentItem((item) => {
            if (item.active) {
              $.each(item.questions, (index, question) => {
                let stimulus = question.stimulus
                if (stimulus) {
                  // let selector = '#stimulus-' + question.response_id
                  let selector = '#' + question.response_id + ' > div.lrn_question > div.lrn_stimulus > div.lrn_stimulus_content'
                  $(selector).children().each(function (i) {
                    let text = $(this).text()
                    if (text.toLowerCase().indexOf('criteria ') === 0) {
                      let label = careerCriteriaList[pos].label
                      let value = careerCriteriaList[pos].value
                      if (value) {
                        $(this).html(label + '<br/>' + value)
                      } else {
                        $(this).html(label)
                      }
                      // let value = $(label).text()
                      // $(selector).html(label)
                      pos++
                    }
                  })
                }
              })
            }
          })
        }
      },

      showUserConversationQuestionMap (sessionId) {
        $('.saved_question_container').remove()
        if (Object.keys(this.userConversationQuestionMap).length > 0) {
          this.itemsApp.getCurrentItem((item) => {
            if (item.active) {
              $.each(item.questions, (index, question) => {
                let match = false
                let responseId = question.response_id
                let parent = '#stimulus-' + responseId
                let container = '#' + responseId + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div'
                $(parent).children().each(function (i) {
                  let text = $(this).text()
                  if ((text.toLowerCase().indexOf('we suggest having 2-3 questions to get your conversation started') !== -1) || (text.toLowerCase().indexOf('criteria ') === 0)) {
                    match = true
                    return false
                  }
                })
                // added for showing feasibility questions
                if (!match) {
                  $(container).children().each(function (i) {
                    let text = $(this).text()
                    if (text.toLowerCase().indexOf('questions') === 0) {
                      match = true
                      return false
                    }
                  })
                }
                if (match) {
                  let key = responseId.substring(sessionId.length + 1)
                  let conversationQuestionList = this.userConversationQuestionMap[key]
                  if (conversationQuestionList && conversationQuestionList.length > 0) {
                    let btnContainerId = 'question_container_' + key
                    let btnContainer = '<p class="saved_question_container" id="' + btnContainerId + '"></p>'
                    $(btnContainer).appendTo($(container))
                    let btnId = 'saved_question_' + key
                    let btnQuestion = '<button type="button" id="' + btnId + '" class="btn btn-default btn-sm">Previously Used Questions</button>'
                    $(btnQuestion).appendTo('#' + btnContainerId)
                    $('#' + btnId).click(() => {
                      this.renderQuestions(key)
                    })
                  }
                }
              })
            }
          })
        }
      },

      renderQuestions (key) {
        let targetId = 'saved_question_' + key
        let questions = this.userConversationQuestionMap[key]
        let index = Object.keys(this.userConversationQuestionMap).indexOf(key)
        switch (index) {
          case 0:
            this.currentQuestions0 = []
            this.currentQuestionId0 = targetId
            $.each(questions, (i, label) => {
              this.currentQuestions0.push(label)
            })
            this.questionListPop0 = !this.questionListPop0
            break
          case 1:
            this.currentQuestions1 = []
            this.currentQuestionId1 = targetId
            $.each(questions, (i, label) => {
              this.currentQuestions1.push(label)
            })
            this.questionListPop1 = !this.questionListPop1
            break
          case 2:
            this.currentQuestions2 = []
            this.currentQuestionId2 = targetId
            $.each(questions, (i, label) => {
              this.currentQuestions2.push(label)
            })
            this.questionListPop2 = !this.questionListPop2
            break
          case 3:
            this.currentQuestions3 = []
            this.currentQuestionId3 = targetId
            $.each(questions, (i, label) => {
              this.currentQuestions3.push(label)
            })
            this.questionListPop3 = !this.questionListPop3
            break
          case 4:
            this.currentQuestions4 = []
            this.currentQuestionId4 = targetId
            $.each(questions, (i, label) => {
              this.currentQuestions4.push(label)
            })
            this.questionListPop4 = !this.questionListPop4
            break
          case 5:
            this.currentQuestions5 = []
            this.currentQuestionId5 = targetId
            $.each(questions, (i, label) => {
              this.currentQuestions5.push(label)
            })
            this.questionListPop5 = !this.questionListPop5
            break
        }
      },

      closeQuestionPopover (index) {
        let ref = 'questionListPopover' + index
        this.$refs[ref].$emit('close')
      },

      replaceWhiteSpace (label) {
        return label.replace(/\s+/g, '').toLowerCase()
      },

      reorderLabelsBasedOnUserCareerCriteriaList () {
        let careerCriteriaList = this.userCareerCriteriaList
        if (careerCriteriaList.length > 0) {
          this.itemsApp.getCurrentItem((item) => {
            if (item.active) {
              $.each(item.questions, (i, question) => {
                let order = 0
                let selector = '#' + question.response_id + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div > p > span:first-child'
                $(selector).each((j, elem) => {
                  let source = careerCriteriaList[order].label
                  let target = this.replaceWhiteSpace($(elem).text())
                  let index = careerCriteriaList.findIndex((x) => this.replaceWhiteSpace($(x.label).text()) === target)
                  if (index !== -1) {
                    $(elem).html(source)
                    order++
                  }
                })
                /*
                let template = question.template
                if (template && (question.type !== 'orderlist')) {
                  let selector = '#' + question.response_id + ' > .lrn_response_wrapper'
                  $('p:even', $(selector)).each(function (id) {
                    if (!$(this).parent().hasClass('label_input_wrapper')) {
                      let wrapper = '<div class="label_input_wrapper" id="label_input_wrapper_id_' + id + '"></div>'
                      $(this).next().addBack().wrapAll(wrapper)
                    }
                  })
                  let replacedItems = []
                  $('div.label_input_wrapper').each((index, target) => {
                    let order = careerCriteriaList[index].order
                    if (index !== order) {
                      let source = replacedItems[index]
                      if (source) {
                        $('#label_input_wrapper_id_' + order).replaceWith(source)
                      } else {
                        replacedItems.splice(order, 0, target)
                        $('#label_input_wrapper_id_' + index).replaceWith($('#label_input_wrapper_id_' + order))
                      }
                    }
                  })
                  let ids = []
                  $("strong[id^='docs-internal-guid-']", template).each((j, elem) => {
                    let id = $(elem).attr('id')
                    if ($.inArray(id, ids) === -1) {
                      ids.push(id)
                    }
                  })
                  $.each(ids, (k, id) => {
                    let label = careerCriteriaList[k].label
                    $('#' + id).html(label)
                  })
                }
                */
              })
            }
          })
        }
      },

      populateUserCareerCriteriaList (question) {
        let careerCriteriaList = []
        // let items = this.itemsApp.getItems()
        let responses = this.itemsApp.getResponses()
        let attemptedItems = this.itemsApp.attemptedItems()
        let elems = (question && question.list) ? question.list : []
        if (attemptedItems && attemptedItems.length > 0) {
          // $.each(this.itemsApp.getCurrentItem().response_ids, (i, responseId) => {
          let response = responses[question.response_id]
          let values = (response && response.value) ? response.value : []
          if (Array.isArray(elems) && elems.length > 0) {
            if (Array.isArray(values) && values.length > 0) {
              $.each(values, (j, value) => {
                let elem = elems[value]
                let content = '<span>' + $(elem).html() + '</span>'
                careerCriteriaList.push({'order': value, 'label': content})
              })
            } else {
              $.each(elems, (i, elem) => {
                let content = '<span>' + $(elem).html() + '</span>'
                careerCriteriaList.push({'order': i, 'label': content})
              })
            }
          }
          // })
        } else {
          $.each(elems, (i, elem) => {
            let content = '<span>' + $(elem).html() + '</span>'
            careerCriteriaList.push({'order': i, 'label': content})
          })
        }
        return careerCriteriaList
      },

      saveUserCareerCriteriaList () {
        if (this.dirty && this.userCareerCriteriaList.length > 0) {
          this.updateUserCareerCriteriaList(this.userCareerCriteriaList).then(res => {
            this.dbUserCareerCriteriaList = this.userCareerCriteriaList
          })
        }
      },

      saveUserCareerCriteriaResponse () {
        let responses = this.itemsApp.getResponses()
        $.each(this.itemsApp.getCurrentItem().response_ids, (i, responseId) => {
          let response = responses[responseId]
          let values = (response && response.value) ? response.value : []
          if (Array.isArray(values) && values.length > 0) {
            let isSaveCareerCriteria = false
            $.each(values, (j, value) => {
              if (value && $.trim(value).length > 0 && this.userCareerCriteriaList[j]) {
                this.userCareerCriteriaList[j].value = value
                isSaveCareerCriteria = true
              }
            })
            if (isSaveCareerCriteria) {
              this.updateUserCareerCriteriaList(this.userCareerCriteriaList).then(res => {
                this.dbUserCareerCriteriaList = this.userCareerCriteriaList
              })
            }
          }
        })
      },

      saveUserTopSkillList (question) {
        let self = this
        let responseId = question.response_id
        let parent = '#' + responseId + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div'
        $(parent).children().each(function (i) {
          let text = $(this).text()
          if (text.toLowerCase().indexOf('what do you excel at') !== -1) {
            let responses = self.itemsApp.getResponses()
            if (Object.keys(responses).length > 0) {
              let response = responses[responseId]
              let values = (response && response.value) ? response.value : []
              if (Array.isArray(values) && values.length > 0) {
                self.userTopSkillList = []
                $.each(values, (i, value) => {
                  if (value) {
                    self.userTopSkillList.push(value)
                  }
                })
                if (self.userTopSkillList.length > 0) {
                  self.updateUserTopSkillList(self.userTopSkillList)
                }
              }
            }
          }
        })
      },

      saveUserMostEnergizeWorkList (question) {
        let self = this
        let responseId = question.response_id
        let parent = '#' + responseId + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div'
        $(parent).children().each(function (i) {
          let text = $(this).text()
          if (text.toLowerCase().indexOf('list the things that  energize  you most at work') !== -1) {
            let responses = self.itemsApp.getResponses()
            if (Object.keys(responses).length > 0) {
              let response = responses[responseId]
              let values = (response && response.value) ? response.value : []
              if (Array.isArray(values) && values.length > 0) {
                self.userMostEnergizeWorkList = []
                $.each(values, (i, value) => {
                  if (value) {
                    self.userMostEnergizeWorkList.push(value)
                  }
                })
                if (self.userMostEnergizeWorkList.length > 0) {
                  self.updateUserMostEnergizeWorkList(self.userMostEnergizeWorkList)
                }
              }
            }
          }
        })
      },

      populateUserConversationQuestionMap (sessionId, question) {
        let self = this
        let responseId = question.response_id
        let parent = '#stimulus-' + responseId
        $(parent).children().each(function (i) {
          let text = $(this).text()
          if ((text.toLowerCase().indexOf('we suggest having 2-3 questions to get your conversation started') !== -1) || (text.toLowerCase().indexOf('criteria ') === 0)) {
            let questionList = []
            let responses = self.itemsApp.getResponses()
            if (Object.keys(responses).length > 0) {
              let response = responses[responseId]
              let values = (response && response.value) ? response.value : []
              if (Array.isArray(values) && values.length > 0) {
                $.each(values, (i, value) => {
                  if (value) {
                    questionList.push(value)
                  }
                })
              }
            }
            let key = responseId.substring(sessionId.length + 1)
            if (questionList.length > 0) {
              if (self.userConversationQuestionMap[key] && self.userConversationQuestionMap[key].length > 0) {
                $.each(questionList, (i, value) => {
                  self.userConversationQuestionMap[key][i] = value
                })
              } else {
                self.userConversationQuestionMap[key] = questionList
              }
            }
          }
        })
        // added for capturing feasibility questions
        let selector = '#' + responseId + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div'
        $(selector).children().each(function (i) {
          let text = $(this).text()
          if (text.toLowerCase().indexOf('questions') === 0) {
            let questionList = []
            let responses = self.itemsApp.getResponses()
            if (Object.keys(responses).length > 0) {
              let response = responses[responseId]
              let values = (response && response.value) ? response.value : []
              if (Array.isArray(values) && values.length > 0) {
                $.each(values, (i, value) => {
                  if (value) {
                    questionList.push(value)
                  }
                })
              }
            }
            let key = responseId.substring(sessionId.length + 1)
            if (questionList.length > 0) {
              if (self.userConversationQuestionMap[key] && self.userConversationQuestionMap[key].length > 0) {
                $.each(questionList, (i, value) => {
                  self.userConversationQuestionMap[key][i] = value
                })
              } else {
                self.userConversationQuestionMap[key] = questionList
              }
            }
          }
        })
      },

      captureCareerIdeaAndConnectionData (question) {
        let self = this
        let careerIdeaAndConnection = {}
        let responseId = question.response_id
        let parent = '#' + responseId + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div'
        $(parent).children().each(function (i) {
          let text = $(this).text()
          if (text.toLowerCase().indexOf('list the idea being the one you are most intrigued by') !== -1) {
            let responses = self.itemsApp.getResponses()
            if (Object.keys(responses).length > 0) {
              let response = responses[responseId]
              let values = (response && response.value) ? response.value : []
              if (Array.isArray(values) && values.length > 0) {
                careerIdeaAndConnection.title = values[0]
                careerIdeaAndConnection.firstName = values[1]
                careerIdeaAndConnection.lastName = values[2]
                careerIdeaAndConnection.organization = values[3]
              }
            }
          }
        })
        return careerIdeaAndConnection
      },

      changeMillisToDate (selected) {
        if (selected) {
          return DateTime.fromMillis(selected, {zone: 'utc'}).toFormat('MM/dd/yyyy')
        }
        return null
      },

      generateConversationWorksheetLink (assessApp, sessionId, externalId) {
        let self = this
        this.itemsApp.getCurrentItem((item) => {
          let featureId = item.feature_ids[0] + '_0'
          $('#' + featureId + ' > div').children().each(function (i) {
            let text = $(this).text()
            if ((text === '#worksheet') || (text === 'View Worksheet')) {
              let btn = '<button type="button" id="worksheet-btn" class="btn btn-default btn-lg" style="background: #f7e5a8;">View Worksheet</button>'
              $(this).html(btn)
              $('#worksheet-btn').click(() => {
                self.loadCareerIdeaAndConnection({courseId: self.courseId, isMainQuest: self.isMainQuest}).then(res => {
                  if (res) {
                    if (!self.isCompleted) {
                      assessApp.submit({
                        success: () => {
                          self.updateAttempt({sessionId: sessionId, externalId: externalId, isFinished: true})
                          let nextEntityDetailInfo = {
                            'courseUuid': self.courseId,
                            'entityType': 'LearningContent',
                            'entityUuid': self.uuid
                          }
                          self.loadNextEntityDetail(nextEntityDetailInfo)
                          setTimeout(() => {
                            self.itemsApp.reset()
                            let courseId = res.conversationCourseId
                            let entityId = res.conversationQuestId
                            window.location.href = '/vue/#/course/' + courseId + '/learn/LearningContent/assessment/' + entityId + '/selective?isMainQuest=false&isMainQuestWorksheet=true'
                            window.location.reload(true)
                          }, 500)
                        },
                        show_submit_ui: false,
                        show_submit_confirmation: false
                      })
                    } else {
                      self.itemsApp.reset()
                      let courseId = res.conversationCourseId
                      let entityId = res.conversationQuestId
                      window.location.href = '/vue/#/course/' + courseId + '/learn/LearningContent/assessment/' + entityId + '/selective?isMainQuest=false&isMainQuestWorksheet=true'
                      window.location.reload(true)
                    }
                  }
                })
              })
              if ($('.test-submit').css('display') !== 'none') {
                $('.test-submit').hide()
              }
            }
          })
        })
      },

      generateExmapleAndNoteButton () {
        $('.note_example_container').remove()
        $.each(this.itemsApp.getCurrentItem().response_ids, (i, id) => {
          let questionObject = this.itemsApp.question(id)
          let question = questionObject.getQuestion()
          let note = question.metadata.hint
          let examples = question.metadata.examples
          if (note || examples) {
            let btnContainer = '<div class="note_example_container" style="margin-top: -5px;"></div>'
            $('#' + id + ' > div.lrn_response_wrapper').after(btnContainer)
            $('#' + id + ' > div.lrn_response_wrapper').css('float', 'left')
            if (note) {
              let btnNote = '<div style="margin-bottom: 10px;"><button type="button" id="note_' + id + '" class="btn btn-default btn-sm">Note</button></div>'
              $(btnNote).appendTo('.note_example_container')
              $('#note_' + id).click(() => {
                this.renderNote(id, note)
              })
            }
            if (examples) {
              let btnExample = '<div><button type="button" id="example_' + id + '" class="btn btn-default btn-sm">Example</button></div>'
              $(btnExample).appendTo('.note_example_container')
              $('#example_' + id).click(() => {
                this.renderExample(id, examples)
              })
            }
          }
        })
      },

      renderNote (questionId, note) {
        this.note = note
        this.noteButtonId = 'note_' + questionId
        this.examplePop = false
        this.notePop = !this.notePop
      },

      renderExample (questionId, examples) {
        this.example = examples[0]
        this.exampleButtonId = 'example_' + questionId
        this.notePop = false
        this.examplePop = !this.examplePop
      },

      generateTopSkillTopCriteriaMostEnergizeLink () {
        let self = this
        $.each(this.itemsApp.getCurrentItem().response_ids, (i, id) => {
          let selector = '#stimulus-' + id
          $(selector).children().each(function (j) {
            let text = $(this).text()
            if (text.toLowerCase().indexOf('brainstorm as many career ideas as you can that leverage your top skills') !== -1) {
              let linkId = 'top_skill_' + id
              let link = '<span style="font-size: 0.9em">Brainstorm as many career ideas as you can that leverage <a href="javascript://" id="' + linkId + '" style="font-size: 0.9em;">your top skills</a></span>'
              $(this).html(link)
              $('#' + linkId).unbind('click').click(() => {
                self.renderTopSkill(linkId)
              })
            } else if (text.toLowerCase().indexOf('brainstorm as many career ideas as you can that prioritize your top criteria') !== -1) {
              let linkId = 'top_criteria_' + id
              let link = '<span style="font-size:0.9em">Brainstorm as many career ideas as you can that prioritize <a href="javascript://" id="' + linkId + '" style="font-size: 0.9em;">your top criteria</a></span>'
              $(this).html(link)
              $('#' + linkId).unbind('click').click(() => {
                self.renderTopCriteria(linkId)
              })
            } else if (text.toLowerCase().indexOf('brainstorm as many career ideas as you can that build on what energizes you the most at work') !== -1) {
              let linkId = 'most_energize_you_' + id
              let link = '<span style="font-size:0.9em">Brainstorm as many career ideas as you can that build on what <a href="javascript://" id="' + linkId + '" style="font-size: 0.9em;">energizes you the most</a> at work</span>'
              $(this).html(link)
              $('#' + linkId).unbind('click').click(() => {
                self.renderEnergizeYouMost(linkId)
              })
            }
          })
        })
      },

      renderTopSkill (linkId) {
        this.topSkillLinkId = linkId
        this.topSkill = []
        for (var i = 0; i < 3; i++) {
          this.topSkill.push(this.userTopSkillList[i])
        }
        this.topCriteriaPop = false
        this.mostEnergizeYouPop = false
        this.topSkillPop = !this.topSkillPop
      },

      renderTopCriteria (linkId) {
        this.topCriteriaLinkId = linkId
        this.topCriteria = []
        for (var i = 0; i < 3; i++) {
          let label = this.userCareerCriteriaList[i].label
          this.topCriteria.push($(label).text())
        }
        this.topSkillPop = false
        this.mostEnergizeYouPop = false
        this.topCriteriaPop = !this.topCriteriaPop
      },

      renderEnergizeYouMost (linkId) {
        this.mostEnergizeYouLinkId = linkId
        this.mostEnergizeYou = []
        for (var i = 0; i < 3; i++) {
          this.mostEnergizeYou.push(this.userMostEnergizeWorkList[i])
        }
        this.topSkillPop = false
        this.topCriteriaPop = false
        this.mostEnergizeYouPop = !this.mostEnergizeYouPop
      },

      saveUserMostInterestingIdeaList (question) {
        let self = this
        let responseId = question.response_id
        // console.log('question: ', question)
        let selector = '#' + responseId + ' > div.lrn_question > div.lrn_stimulus > div.lrn_stimulus_content'
        $(selector).children().each(function (i) {
          let text = $(this).text()
          if (text.toLowerCase().indexOf('review and prioritize') !== -1) {
            let responses = self.itemsApp.getResponses()
            if (Object.keys(responses).length > 0) {
              let response = responses[responseId]
              let values = (response && response.value) ? response.value : []
              if (Array.isArray(values) && values.length > 0) {
                self.userMostInterestingIdeaList = []
                $.each(values, (i, value) => {
                  if (value) {
                    self.userMostInterestingIdeaList.push(value)
                  }
                })
                if (self.userMostInterestingIdeaList.length > 0) {
                  self.updateUserMostInterestingIdeaList(self.userMostInterestingIdeaList)
                }
              }
            }
          }
        })
      },

      showUserMostInterestingIdeaList () {
        let index = 0
        let self = this
        let found = false
        if (self.userMostInterestingIdeaList.length > 0) {
          $.each(this.itemsApp.getCurrentItem().response_ids, (i, id) => {
            let selector = '#' + id + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div > p > span'
            $(selector).children().each(function (j) {
              let text = $(this).text()
              if (text.toLowerCase().indexOf('your top 3 ideas') !== -1) {
                found = true
              }
              if (found) {
                if ((text.toLowerCase().indexOf('#1') !== -1) || (text.toLowerCase().indexOf('#2') !== -1) || (text.toLowerCase().indexOf('#3') !== -1)) {
                  text = text.substring(0, 2)
                  let value = self.userMostInterestingIdeaList[index]
                  if (value) {
                    $(this).text(text + ' ' + value)
                    index++
                  }
                }
              }
            })
          })
        }
      },

      showCreatedCareerIdeaAndConnection () {
        let self = this
        this.itemsApp.getCurrentItem((item) => {
          if (item.active) {
            $.each(item.questions, (i, question) => {
              let parent = '#' + question.response_id + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div'
              if (!self.isMainQuestWorksheet) {
                $(parent).children().each(function (i) {
                  let text = $(this).text()
                  if ((text.toLowerCase().indexOf('discovery conversation sheet') !== -1) || (text.toLowerCase().indexOf('conversation scorecard') !== -1)) {
                    $(this).addClass('d-none')
                  }
                })
              }
              let tableSelector = parent + ' > table.table-bordered > tbody > tr:eq(1)'
              $(tableSelector).children().each(function (i) {
                let text = $(this).text()
                if (text === '#name') {
                  let value = self.dbCareerIdeaAndConnection.firstName + ' ' + self.dbCareerIdeaAndConnection.lastName
                  let elem = '<span id="name">' + (value || '') + '</span>'
                  $(this).html(elem)
                } else if (text === '#organization') {
                  let value = self.dbCareerIdeaAndConnection.organization
                  let elem = '<span id="organization">' + (value || '') + '</span>'
                  $(this).html(elem)
                } else if (text === '#careeridea') {
                  let value = self.dbCareerIdeaAndConnection.title
                  let elem = '<span id="title">' + (value || '') + '</span>'
                  $(this).html(elem)
                } else if ((text === '') || (text === '#date')) {
                  let millis = self.dbCareerIdeaAndConnection.meetingDate
                  let value = self.changeMillisToDate(millis)
                  if (value || (text === '#date')) {
                    let elem = '<span id="meetingDate">' + (value || '') + '</span>'
                    $(this).html(elem)
                  }
                }
              })

              $(parent).children().each(function (i) {
                let text = $(this).text()
                if ((text === '#sample') || (text === 'Sample Questions')) {
                  let btn = '<button type="button" id="conversation-sample-btn" class="btn btn-default btn-lg" style="background: #f7e5a8;">Sample Questions</button>'
                  $(this).css({'float': 'right', 'margin-top': '-100px'}).html(btn)
                  $(this).prev().prev().css({'float': 'left', 'width': '83%'})
                  $('#conversation-sample-btn').click(() => {
                    self.$root.$emit('bv::show::modal', 'conversationSample', null)
                  })
                }
              })
            })
          }
        })
      },

      closeConversationSample () {
        this.$root.$emit('bv::hide::modal', 'conversationSample')
      },

      reset () {
        this.note = undefined
        this.noteButtonId = ''
        this.notePop = false
        this.example = undefined
        this.exampleButtonId = ''
        this.examplePop = false
        this.topSkill = []
        this.topSkillLinkId = ''
        this.topSkillPop = false
        this.topCriteria = []
        this.topCriteriaPop = false
        this.topCriteriaLinkId = ''
        this.mostEnergizeYou = []
        this.mostEnergizeYouPop = false
        this.mostEnergizeYouLinkId = ''
        this.currentQuestionId0 = ''
        this.currentQuestions0 = []
        this.questionListPop0 = false
        this.currentQuestionId1 = ''
        this.currentQuestions1 = []
        this.questionListPop1 = false
        this.currentQuestionId2 = ''
        this.currentQuestions2 = []
        this.questionListPop2 = false
        this.currentQuestionId3 = ''
        this.currentQuestions3 = []
        this.questionListPop3 = false
        this.currentQuestionId4 = ''
        this.currentQuestions4 = []
        this.questionListPop4 = false
        this.currentQuestionId5 = ''
        this.currentQuestions5 = []
        this.questionListPop5 = false
      },

      saveAndExit (sessionId, externalId, isFinished) {
        if (isFinished) {
          this.updateAttempt({sessionId: sessionId, externalId: externalId, isFinished: isFinished}).then(res => {
            if (res && res.isSubmitted) {
              var nextEntityDetailInfo = {
                'courseUuid': this.courseId,
                'entityType': 'LearningContent',
                'entityUuid': this.uuid
              }
              this.loadNextEntityDetail(nextEntityDetailInfo).then(resNext => {
                if (resNext) {
                  if (resNext.title === 'CONVERSATION_SUBMITTED') {
                    if (this.isMainQuestWorksheet) {
                      return this.$router.push({ name: 'clearlyNextStudentDashboard' })
                    } else {
                      return this.$router.push({name: 'connection', params: {careerIdeaId: resNext.uuid}})
                    }
                  } else {
                    return this.$router.push({ name: 'clearlyNextStudentDashboard' })
                  }
                }
              })
            } else {
              this.$notify({
                group: 'notify',
                type: 'warn',
                duration: 5000,
                title: 'Network Error',
                text: 'Failed to connect with item bank. Please re-submit the quest.'
              })
              return this.$router.push({ name: 'clearlyNextStudentDashboard' })
            }
          })
        }
      }
    }
  }
</script>

<style>
    @media (min-width: 900px) {
        .modal .modal-xlg {
            max-width: 80% !important;
            width: 80% !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/app/assessment/components/QuestLaunchAssessment.vue